module.exports = new __parcel__URL__("progress-default-story-points.9c80d50e.svg").toString();